import { render } from "./recovery.vue?vue&type=template&id=452c9e54&scoped=true"
import script from "./recovery.vue?vue&type=script&lang=js"
export * from "./recovery.vue?vue&type=script&lang=js"

import "./recovery.vue?vue&type=style&index=0&id=452c9e54&lang=scss&scoped=true"

import exportComponent from "/Users/ruslan/Desktop/birch/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-452c9e54"]])

export default __exports__